import { CombinedGraphQLErrors } from '@apollo/client/errors';

export const isNotFoundError = (error: unknown) =>
  CombinedGraphQLErrors.is(error) &&
  error.errors.some(e => e.extensions?.code === 'NOT_FOUND');
